import {useDispatch} from 'react-redux'
import {setTrialModalOpen, useTrialModal} from 'entities/app'
import {AdvantageItem} from 'shared/ui/advantageItem'
import {Button} from 'shared/ui/buttons'
import {Close, GoCoin20, Headset, Heart, Messages, PaperClip, Upload} from 'shared/ui/icons'
import {Modal} from 'shared/ui/modal'
import {BalanceImage} from './img/icons'
import styles from './styles.module.scss'


export const TrialModal = () => {
  const dispatch = useDispatch()
  const open = useTrialModal()

  const onCloseHandler = () => dispatch(setTrialModalOpen(false))

  return (
    <Modal open={open} disableAutoFocus disableEnforceFocus onClose={onCloseHandler}>
      <div className={`${styles.containerWrapper} ${styles.customScroll}`} onClick={onCloseHandler}>
        <div className={styles.container} onClick={(e) => e.stopPropagation()}>
          <div className={styles.topBlock}>
            <div className={styles.title}>
              <div className={styles.closeBtn} onClick={onCloseHandler}>
                <Close />
              </div>
            </div>
            <div className={styles.balance}>
              <BalanceImage />
            </div>
          </div>
          <div className={styles.bottomBlock}>
            <h1 className={styles.title}>Premium features unlocked for you</h1>
            <div className={`${styles.advantages} ${styles.customScroll}`}>
              <AdvantageItem
                icon={<GoCoin20 />}
                title='Free GoCoins x20'
                description='These coins can be spent on socializing, gifts, stickers, etc.'
              />
              <AdvantageItem
                icon={<PaperClip />}
                title='Share content in chat'
                description='Send photos or videos in chats.'
              />
              <AdvantageItem
                icon={<Headset />}
                title='Premium support'
                description='Get instant answers and help 24/7.'
              />
              <AdvantageItem
                icon={<Upload />}
                title='Profile search promotion'
                description='Your profile will appear higher than those with the free package.'
                isNew
              />
              <AdvantageItem
                icon={<Heart />}
                title='Get x3 super matches'
                description='Our system will select for you profiles with the highest possible similarity.'
              />
              <AdvantageItem
                icon={<Messages />}
                title='Top in Messenger'
                description='Appear at the top of conversations.'
              />
            </div>
          </div>
          <div className={styles.btnContainer}>
            <Button fullwidth styleType='primary' onClick={onCloseHandler}>Let's go</Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}